import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { get, find, join, keys, forIn } from 'lodash';
import moment from 'moment';
// import countries from 'data/countries';
import { Row, Col, Popover } from 'antd';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import currency from 'utils/currency';
import { StyledUl } from 'components/Styled';
import { getCountriesRequest } from 'ducks/shipments';

import helpers from 'utils/helpers';

const Coupon = props => {
  const { coupon } = props;
  const { rules } = coupon;
  const { t } = useTranslation();

  useEffect(() => {
    props.getCountriesRequest();
  }, []);

  const getRouteString = () => {
    switch (rules.route) {
      case 'all':
        return t('promo_codes.all_route');
      case 'import':
        return t('promo_codes.import');
      case 'export':
        return t('promo_codes.export');
      default: {
        const from = get(
          find(props.countries, ['alpha-2', rules.from]),
          `name.${t('key')}`
        ) || rules.from;

        const to = get(
          find(props.countries, ['alpha-2', rules.to]),
          `name.${t('key')}`
        ) || rules.to;

        return `${from}${t('promo_codes.ship_to')}${to}`;
      }
    }
  };

  const getConstraintString = () => {
    const arr = [];

    if (rules?.amount) {
      arr.push(
        t('promo_codes.min_charge', {
          amount: new currency(rules.amount).format()
        })
      );
    }

    if (coupon.expiresAt) {
      arr.push(
        t('promo_codes.use_before', {
          expiry_date: moment(coupon.expiresAt).format('MMM DD YYYY')
        })
      );
    }

    return join(arr, ' | ');
  };

  const getCarrierData = services => {
    const k = keys(services);

    switch (k.length) {
      case 0:
        return;
      case 1: {
        const data = services[k[0]];
        const { carrier, carrierName, name } = data;

        return (
          <div>
            {helpers.responsiveImage(
              helpers.getCarrierImage(carrier),
              carrierName[t('key')],
              helpers.getCarrierImageWidth(carrier, 0.8)
            )}
            <span
              style={{
                paddingLeft: '8px'
              }}>
              {name[t('key')]}
            </span>
          </div>
        );
      }
      default: {
        return (
          <>
            {t('promo_codes.available_services')}{' '}
            <Popover
              content={(() => {
                const arr = [];
                forIn(services, data => {
                  const { carrierName, name } = data;
                  arr.push(`${carrierName[t('key')]} ${name[t('key')]}`);
                });

                return (
                  <StyledUl>
                    {arr.map(x => (
                      <li key={x}>{x}</li>
                    ))}
                  </StyledUl>
                );
              })()}
              placement="bottom">
              <span
                className="buttonSecond-color"
                style={{ color: '#57D7DD', fontSize: '12px' }}>
                <FontAwesomeIcon icon="exclamation-circle" />
              </span>
            </Popover>
          </>
        );
      }
    }
  };

  const renderValue = (coupon) => {
    const { type, value, amount } = coupon;
    if (type === 'fixed') {
      return new currency(amount || value).format();
    } else if (type === 'percentage') {
      return `${value}%`
    }
  };

  return (
    <>
      <div
        style={{
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
          backgroundColor: '#fff',
          padding: '20px 15px',
          margin: '10px 0'
        }}>
        <Row type="flex" align="middle">
          <Col span={9}>
            <span
              className="buttonSecond-color"
              style={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#9900A5',
                lineHeight: 1
              }}>
              {renderValue(coupon)}
              <br />
              OFF
            </span>
          </Col>
          <Col
            span={15}
            style={{
              textAlign: 'right',
              fontSize: '10px'
            }}>
            <div
              style={{
                color: '#2C2C2E'
              }}>
              {getCarrierData(coupon.services)}
            </div>
            <div
              style={{
                fontWeight: 700,
                padding: '5px 0',
                fontSize: '14px'
              }}>
              {getRouteString()}
            </div>
            <div
              style={{
                color: '#2C2C2E'
              }}>
              {getConstraintString()}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getCountriesRequest
};

const mapStateToProps = state => {
  return {
    countries: state.shipments.countries || []
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Coupon);
